import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/IndexView.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: HomeView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
